import { Box, Grid, Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { LanguageContext } from '../../../../../../../../../libs/Context';

const ThankYou = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { setComponent } = props;

	return (
		<Grid container justifyContent={'center'} alignItems={'center'}>
			<Grid item xs={12} >
				<Stack direction={'column'} spacing={2} alignItems={'center'} justifyContent={'center'}>
					<Box sx={{ height: '70px', width: '70px' }}
						component='img'
						src='/images/icons/successregistration.svg'
					/>
					<Stack direction={'column'} spacing={1} justifyContent={'center'} alignItems={'center'}>
						<Typography variant='body1' fontWeight='var(--font500)' fontSize={'var(--pixel18)'}>{language?.thankYou}</Typography>
						<Typography variant='body1' onClick={() => setComponent(3)} fontWeight='var(--font500)' fontSize={'var(--pixel24)'}>{language?.sucesfulyRegistered}</Typography>
						<Typography variant='body1' fontSize={'var(--pixel14)'} color={'rgba(126, 146, 162, 1)'}>{language?.webinarLinkEmail} </Typography>
					</Stack>
				</Stack>
			</Grid>
		</Grid>
	);
};

export default ThankYou;
